import React, { useState, useEffect } from "react";
import { masterRateCardAPI } from "../../api/RateCardApi";
import { message, Select, Spin } from "antd";

const CloneRateCardTemplate = ({ getTemplateData = () => {} }) => {
  const [rateCardList, setRateCardList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchText, setSearchText] = useState("");
  ////const containerRef = useRef(null);

  useEffect(() => {
    loadRateCards(0, searchText, true); // Load first page on mount
  }, []);

  const loadRateCards = async (pageNum, search = "", isNewSearch = false) => {
    if (loading) return;

    setLoading(true);
    try {
      const response = await masterRateCardAPI.getAllRateList({
        pageNum: pageNum,
        pageSize: 20,
        name: search,
      });

      if (response?.status) {
        const items = response?.response?.data?.items || [];

        setRateCardList((prev) => (isNewSearch ? items : [...prev, ...items]));
        setHasMore(items.length > 0);
        setPage(pageNum);
      } else {
        message.error(response?.response?.data?.message || "Network Error");
      }
    } finally {
      setLoading(false);
    }
  };

  const getTemplateDetails = async (templateId) => {
    const response = await masterRateCardAPI.getRateById(templateId);
    getTemplateData(response?.response?.data);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore && !loading) {
      loadRateCards(page + 1, searchText);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    loadRateCards(0, value, true);
  };

  return (
    <Select
      showSearch
      placeholder="Select Template"
      onSearch={handleSearch}
      onPopupScroll={handleScroll}
      notFoundContent={loading ? <Spin size="small" /> : "No templates found"}
      options={rateCardList.map((item) => ({
        label: item.name,
        value: item.rateCardId,
      }))}
      onChange={(value) => getTemplateDetails(value)}
      filterOption={false} // disables default filtering so API search is used
      style={{ width: "100%" }}
    />
  );
};

export default CloneRateCardTemplate;
